export default "__VITE_ASSET__CYaYoNv5__"